import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'InkCore',
  brandName: 'InkCore',
  description: 'Sistema de agendamento para tatuadores',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Estúdio de tatuagem',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Tatuador trabalhando',
  },
  testimonials: [
    {
      name: 'Rafaela "Inky" Silva',
      role: 'Tatuadora',
      text: 'Com o InkCore, a gestão das sessões e dos clientes ficou muito mais fácil. Tenho mais tempo para criar!',
      image: testimonial1,
    },
    {
      name: 'Diogo Costa',
      role: 'Cliente',
      text: 'Marcar a minha tatuagem foi super fácil e o sistema de portfólio online ajudou-me a escolher o artista.',
      image: testimonial2,
    },
    {
      name: 'Estúdio Tinta na Pele',
      role: 'Dono do Estúdio',
      text: 'Uma ferramenta essencial para qualquer estúdio de tatuagens. Organização e profissionalismo de topo.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'tatuador',
    professionals: 'tatuadores',
    business: 'estúdio',
    businesses: 'estúdios',
    service: 'tatuagem',
    services: 'tatuagens',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'sessão',
    appointments: 'sessões',
  },
  homepage: {
    hero: {
      badge: 'Arte Corporal',
      title: 'Crie arte permanente com InkCore',
      description: 'Gerencie suas sessões de tatuagem e transforme pele em canvas com o suporte do InkCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '180+', label: 'Tatuadores' },
      { value: '12k+', label: 'Tatuagens Realizadas' },
      { value: '95%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Sessões Longas Mal Planeadas',
        description: 'Tatuagens grandes requerem múltiplas sessões, mas gerir isso manualmente é complicado.',
        icon: 'Clock',
        quote: {
          text: 'Antes do InkCore perdi várias manhãs reorganizando sessões de tatuagens que duravam 6+ horas',
          author: 'Tomás Ferreira',
          business: 'Black Ink Studio',
        },
      },
      {
        title: 'Depósitos e Pagamentos',
        description: 'Gerir depósitos e pagamentos finais manualmente gera confusão e atrasos.',
        icon: 'CreditCard',
        stats: [
          { label: 'Atraso em pagamentos sem sistema:', value: '40%' },
          { label: 'Tempo perdido com cobrança:', value: '8h/semana' },
        ],
      },
      {
        title: 'Portfolio e Referências',
        description: 'Mostrar trabalhos anteriores e discutir designs por WhatsApp é desorganizado.',
        icon: 'Image',
        quote: {
          text: 'Com o portfolio digital consigo mostrar meu trabalho profissionalmente e fechar mais tatuagens',
          author: 'Mariana Alves',
          business: 'Rebel Art Tattoo',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'InkCore: O seu estúdio digital',
      description: 'Tecnologia desenhada para tatuadores que valorizam arte e profissionalismo.',
      features: [
        {
          title: 'Sessões Múltiplas',
          description: 'Agende automaticamente sessões consecutivas para projetos grandes respeitando tempo de cicatrização.',
        },
        {
          title: 'Gestão de Depósitos',
          description: 'Controle depósitos, pagamentos finais e histórico financeiro de cada cliente.',
        },
        {
          title: 'Portfolio Digital',
          description: 'Apresente seus trabalhos profissionalmente e permita clientes explorarem seu estilo.',
        },
      ],
    },
    testimonials: {
      title: 'O que os tatuadores dizem',
      description: 'Tatuadores que elevaram seu profissionalismo com o InkCore.',
    },
    finalCta: {
      title: 'Pronto para digitalizar seu estúdio?',
      description: 'Junte-se aos tatuadores que já profissionalizaram sua arte com o InkCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de tatuador',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
